import type { ReactElement } from 'react';
import SpaceY from '../../../../components/SpaceY';
import { MAX_WIDTH_639PX } from '../../../../utils/common';
import useClientMediaQuery from '../../../../utils/hook/useClientMediaQuery';

interface Props {
  index: number;
  title: string | ReactElement;
  description: string | ReactElement;
  children?: ReactElement;
}

const SourcingWrapper = ({ index, title, description, children }: Props) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  return (
    <div>
      <hr className="border-brand-1" />

      <SpaceY height={48} />
      <div
        className={isMobile ? 'grid-row-2 grid gap-24px' : 'grid grid-cols-2'}
      >
        <h1 className="text-30px font-bold leading-[42px] text-brand-1 sm:text-34px sm:leading-[44.2px]">
          원칙 {index}
          <br />
          {title}
        </h1>

        <p className="text-18px leading-[28.8px] text-brand-1 ">
          {description}
        </p>
      </div>

      {children && (
        <>
          <SpaceY height={32} />
          {children}
        </>
      )}
    </div>
  );
};

export default SourcingWrapper;
